<template>
  <button
    v-if="$content.options.value.navigation?.main?.booking_label"
    class="button button-secondary"
    type="button"
    @click.stop="openBookingModal"
  >
    {{ $content.options.value.navigation.main.booking_label }}
  </button>
</template>

<script lang="ts">
import { useModalStore } from '@/stores/modal.ts'

export default {
  name: 'BookingLink',
  methods: {
    openBookingModal() {
      const bookings = this.$content.options.value.navigation?.main?.bookings ?? []

      if (!bookings.length) return

      useModalStore().openBooking(bookings)
    },
  },
}
</script>
